import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import { Page } from 'theme/elements/Page';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { SystemMessagesTable } from 'sections/SystemMessages/SystemMessagesTable';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getSystemMessagesError, setError } from 'state/reducers/system-messages.reducer';
import { getToken } from 'state/reducers/auth.reducers';
import { getUserDetails } from 'state/reducers/user.reducers';
import { WarningDialog } from 'components/WarningDialog';
import { hasPermission } from 'components/AuthorizationComponent';
import { permissionEnums } from 'constants/permission.constants';
import { pagesEnum } from 'constants/ui.constants';

export const SystemMessagesApp = () => {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const error = useAppSelector(getSystemMessagesError);
	const token = useAppSelector(getToken);
	const { permissions } = useAppSelector(getUserDetails);
	const permissionList = Array.isArray(permissions) ? permissions : permissions?.permissions;
	const canView = hasPermission([permissionEnums.VIEW_SYSTEM_MESSAGES]);
	const canCreate = hasPermission([permissionEnums.CREATE_SYSTEM_MESSAGE]);

	useEffect(() => {
		if (token && (!permissionList || permissionList.length === 0)) {
			return;
		}
		if (!canView) {
			navigate(`/${pagesEnum.PAGE_NOT_FOUND}`);
		}
	}, [token, permissionList, canView, navigate]);

	if (!canView) {
		return null;
	}

	return (
		<Page title={t('page.systemMessages.title')} subTitle={t('page.systemMessages.subtitle')}>
			<WarningDialog
				open={error.exist}
				subTitle={error.text ? t(error.text) : ''}
				handleCancel={() => dispatch(setError({ exist: false }))}
			/>
			<Stack spacing={3}>
				{canCreate && (
					<Stack direction="row" justifyContent="flex-end">
						<Button variant="contained" onClick={() => navigate(`/${pagesEnum.SYSTEM_MESSAGES_CREATE}`)}>
							{t('page.systemMessages.action.createNew')}
						</Button>
					</Stack>
				)}
				<SystemMessagesTable />
			</Stack>
		</Page>
	);
};
